import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IUnitModuleNodeUsage {
    applicationPermissionType: ApplicationPermissionType;
    inUse: boolean;
    enabled: boolean;
    visible: boolean;

    getTitle(isSuperAdmin: boolean, canUseRecords: boolean): string;
}

export class UnitModuleNodeUsage implements IUnitModuleNodeUsage {
    applicationPermissionType: ApplicationPermissionType;
    inUse: boolean;
    enabled: boolean;
    visible: boolean;

    constructor();
    constructor(obj: IUnitModuleNodeUsage);
    constructor(obj?: any) {
        this.applicationPermissionType = obj && obj.applicationPermissionType || 0;
        this.inUse = obj && obj.inUse || false;
        this.enabled = obj && obj.enabled || false;
        this.visible = obj && obj.visible || false;
    }

    getTitle(isSuperAdmin: boolean, canUseRecords: boolean): string {
        switch (this.applicationPermissionType) {
        case ApplicationPermissionType.Message:
            return Translations.CurrentTopics;
        case ApplicationPermissionType.Document:
            return Translations.Documents;
        case ApplicationPermissionType.Event:
            return Translations.Events;
        case ApplicationPermissionType.Task:
            return Translations.Tasks;
        case ApplicationPermissionType.Record:
            return canUseRecords
                ? Translations.Resources
                : Translations.RecordUser;
        case ApplicationPermissionType.CompanyGroup:
            return Translations.CompanyGroups;
        case ApplicationPermissionType.Company:
            return isSuperAdmin
                ? Translations.Companies
                : Translations.Company;
        case ApplicationPermissionType.UserGroup:
            return Translations.UserGroups;
        case ApplicationPermissionType.User:
            return Translations.Users;
        case ApplicationPermissionType.Log:
            return Translations.Log;
        case ApplicationPermissionType.WhistleBlow:
            return Translations.WhistleBlow;
        case ApplicationPermissionType.CalendarTask:
            return Translations.Calendar;
        case ApplicationPermissionType.AppReport:
            return Translations.Reports;
        case ApplicationPermissionType.Risk:
            return Translations.RiskManagement;
        default:
            return "";
        }
    }
}